module.exports = __webpack_public_path__ + "static/img/info_title6.4cb0e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_title6.png
// module id = IlT5
// module chunks = 4